import React from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import _ from 'lodash'

class FontStyle extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    disableKeys: PropTypes.array,
    onChange: PropTypes.func
  };

  static defaultProps = {
    disableKeys: [],
    data: {
      fontWeight: 'normal',
      fontStyle: 'normal',
      textDecoration: 'none'
    }
  };

  constructor(props) {
    super(props)

    const { data } = props
    this.state = {
      fontWeight: (data && data.fontWeight) || 'normal',
      fontStyle: (data && data.fontStyle) || 'normal',
      textDecoration: (data && data.textDecoration) || 'none'
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.data, nextProps.data)) {
      const { data } = nextProps
      this.setState({
        fontWeight: (data && data.fontWeight) || 'normal',
        fontStyle: (data && data.fontStyle) || 'normal',
        textDecoration: (data && data.textDecoration) || 'none'
      })
    }
  }

  render() {
    const { disableKeys } = this.props
    const { fontWeight, fontStyle, textDecoration } = this.state

    return (
      <div>
        {
          this.FONT_STYLES.map((item) => {
            if (disableKeys.indexOf(item.key) > -1) {
              return null
            }
            let active = false
            if (item.key === 'bold') {
              active = fontWeight === item.key
            } else if (item.key === 'italic') {
              active = fontStyle === item.key
            } else if (item.key === 'underline') {
              active = textDecoration === item.key
            }

            const _clsName = classnames('diagram-title-font-style-icon', {
              [item.key]: true,
              active
            })

            return (
              <i key={`diagram-title-font-style-${item.key}`}
                title={item.name}
                className={_clsName}
                onClick={this.handleChangeStyle.bind(this, item.key, !active)}
              >
                {item.icon}
              </i>
            )
          })
        }
      </div>
    )
  }

  handleChangeStyle(key, active) {
    this.setState((prevState) => {
      if (key === 'bold') {
        return {
          ...prevState,
          fontWeight: active ? key : 'normal'
        }
      }

      if (key === 'italic') {
        return {
          ...prevState,
          fontStyle: active ? key : 'normal'
        }
      }

      if (key === 'underline') {
        return {
          ...prevState,
          textDecoration: active ? key : 'none'
        }
      }
      return {}
    }, () => {
      this.props.onChange(this.state)
    })
  }

  FONT_STYLES = [{
    name: '下划线',
    key: 'underline',
    icon: 'U'
  }, {
    name: '倾斜',
    key: 'italic',
    icon: 'I'
  }, {
    name: '加粗',
    key: 'bold',
    icon: 'B'
  }]
}

export default FontStyle
